






import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'UCTabContent',
  props: {
    value: {
      type: String,
      required: true,
    },
    activeTab: {
      type: String,
      default: '',
    },
  },
  computed: {
    isSelected(): boolean {
      return this.activeTab === this.value;
    },
  },
});
